import { type RootState } from "../../../../Application/globaltypes/redux";
import { videosStateSelector } from "./index";

export const videoSearchSelector = (state: RootState) => videosStateSelector(state).overview.filters.search;
export const videoAppliedFilterSelector = (state: RootState) =>
  videosStateSelector(state).overview.filters.appliedFilter;
